module.exports = __webpack_public_path__ + "img/success.a87ba918.png";